var render = function () {
  var _vm$personalData, _vm$personalData$gend;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "card"
  }, [_c('v-card-title', {
    staticClass: "accent--text pb-4"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("Персональные данные")])]), _c('v-card-text', {
    staticClass: "border-top",
    attrs: {
      "outlined": "",
      "tile": ""
    }
  }, [_c('v-row', {
    staticClass: "px-3 pt-3"
  }, [(_vm$personalData = _vm.personalData) !== null && _vm$personalData !== void 0 && _vm$personalData.id ? [_c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "accent--text font-weight-bold"
  }, [_vm._v("Пол")]), _c('div', {
    staticClass: "accent--text"
  }, [_vm._v(_vm._s((_vm$personalData$gend = _vm.personalData.gender) === null || _vm$personalData$gend === void 0 ? void 0 : _vm$personalData$gend.name))])]), _vm._l(_vm.personalData.personalNameList, function (item, i) {
    return _c('v-col', {
      key: i,
      staticClass: "pa-0 border-top",
      attrs: {
        "cols": "12"
      }
    }, [_c('v-col', {
      staticClass: "pt-3 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("ФИО")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.fullName))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("ФИО в родительном падеже")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.fullNameGenitive))])])], 1);
  }), _vm._l(_vm.personalData.personalContactList, function (item, i) {
    return _c('v-col', {
      key: i + 50,
      staticClass: "pa-0 border-top",
      attrs: {
        "cols": "12"
      }
    }, [_c('v-col', {
      staticClass: "pt-3 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Мобильный телефон")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.cellularPhone))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Домашний телефон")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.homePhone || '-'))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("E-mail")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.email))])])], 1);
  }), _vm._l(_vm.personalData.addressGarList, function (item, i) {
    var _item$addressType, _item$country;

    return _c('v-col', {
      key: i + 100,
      staticClass: "pa-0 border-top",
      attrs: {
        "cols": "12"
      }
    }, [_c('v-col', {
      staticClass: "pt-3 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Вид регистрации")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s((_item$addressType = item.addressType) === null || _item$addressType === void 0 ? void 0 : _item$addressType.name))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Страна")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s((_item$country = item.country) === null || _item$country === void 0 ? void 0 : _item$country.name))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Адрес")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.fullAddress))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Квартира")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.flat))])]), _c('v-col', {
      staticClass: "pt-0 px-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "accent--text font-weight-bold"
    }, [_vm._v("Индекс")]), _c('div', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.postalCode))])])], 1);
  })] : [_c('v-col', {
    staticClass: "pt-0 px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "accent--text"
  }, [_vm._v("Нет данных")])])]], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }